export class Form1 {
  public static prev_strD_class: string = "";
}
